import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';

export interface ShipInfo {
  aisType: string;
  country: string;
  imo: string;
  name: string;
  mmsi: string;
  width: string;
  length: string;
  draught: string;
  heading: string;
  destination: string;
  rateOfTurn: string;
  courseOverGround: string;
  speedOverGround: string;
  lastAisLatitude: string;
  lastAisLongitude: string;
  lastAisSatLatitude: string;
  lastAisSatLongitude: string;
  latitudeDegrees: string;
  longitudeDegrees: string;
  latitude: number;
  longitude: number;
  callSign: string;
  shipType: string;
  cargoType: string;
  sourceType: string;
  eta: Date | null;
  portEta: Date | null;
  lastAisReport: Date | null;
  lastAisSatReport: Date | null;
  lastOrigin: string;
  posAccuracy: string;
  flag: string;
  navigationalStatus: string;
}

export interface ShipInfoByPropertiesProps {
  type: string | null;
  mmsi: string | null;
  imo: string | null;
  name: string | null;
  callSign: string | null;
  filteredOut?: boolean;
}

export interface Target {
  ambiguousTargets: any[];
  lat: number;
  lon: number;
  result: string;
  x: number;
  y: number;
}

const desiredTargetName: string[] = [
  'Last AIS Latitude',
  'Last AIS Longitude',
  'Last AIS-Sat Latitude',
  'Last AIS-Sat Longitude',
  'Latitude',
  'Longitude',
  'Port ETA',
];

const desiredIds: string[] = [
  'type',
  'country',
  'imo',
  'name',
  'mmsi',
  'destination',
  'sog',
  'draught',
  'cog',
  'heading',
  'rot',
  'width',
  'length',
  'callsign',
  'shiptype',
  'cargotype',
  'dst',
  'eta',
  'lastaisreport',
  'lastorigin',
  'posaccuracy',
  'lastaissatreport',
  'flag',
  'navstatus',
];

export function extractShipInfos(result: QueryPointResult): ShipInfo[] {
  const shipInfos: ShipInfo[] = [];

  for (const target of result.targetInfo) {
    const rawShipInfo: { [key: string]: string } = {};
    for (const target_value of target.values) {
      if (desiredIds.includes(target_value.id)) {
        rawShipInfo[target_value.id] = target_value.value;
      }
      if (desiredTargetName.includes(target_value.name)) {
        rawShipInfo[target_value.name] = target_value.value;
      }
    }

    const shipInfo: ShipInfo = {
      aisType: rawShipInfo['type'],
      country: rawShipInfo['country'],
      imo: rawShipInfo['imo'],
      name: rawShipInfo['name'],
      mmsi: rawShipInfo['mmsi'],
      width: rawShipInfo['width'],
      length: rawShipInfo['length'],
      draught: rawShipInfo['draught'],
      heading: rawShipInfo['heading'],
      destination: rawShipInfo['destination'],
      rateOfTurn: rawShipInfo['rot'],
      courseOverGround: rawShipInfo['cog'],
      speedOverGround: rawShipInfo['sog'],
      lastAisLatitude: rawShipInfo['Last AIS Latitude'],
      lastAisLongitude: rawShipInfo['Last AIS Longitude'],
      lastAisSatLatitude: rawShipInfo['Last AIS-Sat Latitude'],
      lastAisSatLongitude: rawShipInfo['Last AIS-Sat Longitude'],
      latitudeDegrees: rawShipInfo['Latitude'],
      longitudeDegrees: rawShipInfo['Longitude'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      callSign: rawShipInfo['callsign'],
      shipType: rawShipInfo['shiptype'],
      cargoType: rawShipInfo['cargotype'],
      sourceType: rawShipInfo['dst'],
      eta: parseDate(rawShipInfo['eta']),
      portEta: parseDate(rawShipInfo['Port ETA']),
      lastAisReport: parseDate(rawShipInfo['lastaisreport']),
      lastAisSatReport: parseDate(rawShipInfo['lastaissatreport']),
      lastOrigin: rawShipInfo['lastorigin'],
      posAccuracy: rawShipInfo['posaccuracy'],
      flag: rawShipInfo['flag'],
      navigationalStatus: rawShipInfo['navstatus'],
    };
    shipInfos.push(shipInfo);
  }

  return shipInfos;
}
